export default {
    person: '',
    person_mother: '孩子妈妈',
    person_principal: '机构负责人',
    person_worker: '职场白领',
    person_student: '留学生',

    intro: '哈兔简介',
    intro_distribute: '学员分布',
    intro_area: '师资力量 ',
    intro_cctv: 'CCTV专题报道',
    intro_un: '专注在线中文教育8年',

    cooperation: '合作联系',
    cooperation_btn: '提交申请',

    contact: '邮件联系',
    contact_step1: '点击下载联系按钮',
    contact_step2: '填写联系表',
    contact_step3: '发送联系表到指定邮箱',
    contact_btn1: '下载联系表(企业版)',
    contact_btn2: '下载联系表(个人版)',
    contact_tip: '填写完毕后，请发送至邮箱sc@ihatoo.com ，工作人员将在 2-3个工作日联系您',
};